module.exports = __webpack_public_path__ + "img/img_016@2x.d4d1b468.png";